// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
import ApiService from "@/core/services/api.service";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user_permissions: JSON.parse(localStorage.getItem('user_permissions')) || [],
        user_roles: JSON.parse(localStorage.getItem('user_roles')) || []
    },

    actions: {
        async FETCH_USER_PERMISSIONS({ commit }) {
            try {
                const res = await ApiService.get("/users/permissions");
                const perms = res?.data?.permissions;
                const roles = res?.data?.roles;
                commit("SET_USER_PERMISSIONS", Array.isArray(perms) ? perms : []);
                commit("SET_USER_ROLES", Array.isArray(roles) ? roles : []);
                return perms;
            } catch (e) {
                // Keep existing permissions if fetch fails.
                return null;
            }
        }
    },

    mutations: {
        SET_USER_PERMISSIONS(state, permissions) {
            state.user_permissions = permissions
            // Keep in sync with localStorage
            localStorage.setItem('user_permissions', JSON.stringify(permissions))
        },
        SET_USER_ROLES(state, roles) {
            state.user_roles = roles
            localStorage.setItem('user_roles', JSON.stringify(roles))
        },

        CLEAR_USER_PERMISSIONS(state) {
            state.user_permissions = []
            localStorage.removeItem('user_permissions')
            state.user_roles = []
            localStorage.removeItem('user_roles')
        }
    },

    getters: {
        user_permissions: state => state.user_permissions,
        user_roles: state => state.user_roles,
        permissionsSet: state => new Set(state.user_permissions || [])
    }
})